import { NewUiZoneWidgetConfig } from '@finxone-platform/shared/sys-config-types';

export function getWidgetClasses(widget: NewUiZoneWidgetConfig) {
  return `${widget.name} ${widget.uniqueId}`;
}
